import http from '@/common/utils/http-common';
import Employee, { EmployeeRequest } from '@/types/Employee.type';

class EmployeeService {
  getAll() {
    return http.get('/employees');
  }

  get(id: string | number) {
    return http.get(`/employees/${id}`);
  }

  create(data: EmployeeRequest) {
    return http.post('/employees', data);
  }

  update(data: EmployeeRequest, id: any) {
    return http.put(`/employees/${id}`, data);
  }

  delete(id: number) {
    return http.delete(`/employees/${id}`);
  }

  updateProfile(data: Employee) {
    return http.put(`/employees/profile`, data);
  }

  updateAutoFlag(data: { autoUpdateFlag: boolean }) {
    return http.put(`/employees/profile`, data);
  }

  getExclusionMyGroup(id: string | number) {
    return http.get(`/employees/exclusion-my-group/${id}`);
  }
}

export default new EmployeeService();
